module.exports = __webpack_public_path__ + "static/action-good-hours-c787ba1d5f48e50c0edc1c67bbe51ad3.jpg";